module.exports = __webpack_public_path__ + "img/cuba.8388805c.png";